var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 18 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "参数名",
                    "label-col": { span: 6 },
                    "wrapper-col": { span: 12 },
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["scKey", _vm.rules.scKey],
                        expression: "['scKey', rules.scKey]",
                      },
                    ],
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 18 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "参数值",
                    "label-col": { span: 6 },
                    "wrapper-col": { span: 12 },
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["scValue", _vm.rules.scValue],
                        expression: "['scValue', rules.scValue]",
                      },
                    ],
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 18 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "描述",
                    "label-col": { span: 6 },
                    "wrapper-col": { span: 12 },
                  },
                },
                [
                  _c("a-textarea", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["description"],
                        expression: "['description']",
                      },
                    ],
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "UPDATE",
                  expression: "`UPDATE`",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save()
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }